// Static content for Equinoxe Propreté

export const COMPANY = {
  name: "Equinoxe Propreté",
  group: "Groupe Equinoxe",
  phone: "05 32 18 90 44",
  phoneRaw: "0532189044",
  whatsapp: "33532189044",
  email: "contact@equinoxeproprete.fr",
  addresses: ["46000 Cahors", "46250 Cazals"],
  accent: "#0ea5e9",
  logo: "https://customer-assets.emergentagent.com/job_proprete-cahors/artifacts/b8gfdi2e_Equinoxe_Proprete_blanc-resize-2.png",
};

export const HERO_IMG =
  "https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwcmlzdGluZSUyMGJyaWdodCUyMGxpdmluZyUyMHJvb20lMjBzdW5saWdodHxlbnwwfHx8fDE3ODIzODY2NTh8MA&ixlib=rb-4.1.0&q=85";

export const SERVICES = [
  {
    slug: "menage-entretien-interieur",
    icon: "Sparkles",
    title: "Ménage & entretien intérieur",
    short:
      "Ménage régulier ou ponctuel de résidence principale, secondaire et locations saisonnières.",
    image:
      "https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxwcmlzdGluZSUyMGJyaWdodCUyMGxpdmluZyUyMHJvb20lMjBzdW5saWdodHxlbnwwfHx8fDE3ODIzODY2NTh8MA&ixlib=rb-4.1.0&q=85",
    details: [
      "Ménage régulier ou ponctuel (résidence principale, secondaire, location saisonnière)",
      "Bricolage et montage de meubles",
      "Nettoyage de surfaces vitrées",
      "Gardiennage, présence dissuasive lors d'absence",
      "Relève du courrier",
    ],
  },
  {
    slug: "entretien-exterieur-espaces-verts",
    icon: "Leaf",
    title: "Entretien extérieur & espaces verts",
    short: "Tonte, débroussaillage, taille de haies et entretien de vos extérieurs.",
    image:
      "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    details: [
      "Tonte et débroussaillage",
      "Taille de haies",
      "Entretien de massifs",
      "Nettoyage de terrasse, balcon, allée, façade",
    ],
  },
  {
    slug: "nettoyage-surfaces-vitrees",
    icon: "AppWindow",
    title: "Nettoyage de surfaces vitrées",
    short: "Fenêtres, baies vitrées, vérandas, velux et vitrines impeccables.",
    image:
      "https://images.pexels.com/photos/31435403/pexels-photo-31435403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    details: [
      "Fenêtres, porte-fenêtres, baies vitrées",
      "Véranda et velux",
      "Vitrine de magasin",
      "Volets roulants",
    ],
  },
  {
    slug: "debarras-desinfection",
    icon: "Trash2",
    title: "Débarras & désinfection",
    short: "Débarras de tous locaux, nettoyage, désinfection et mise en déchetterie.",
    image:
      "https://images.unsplash.com/photo-1577412647305-991150c7d163?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBjb21tZXJjaWFsJTIwY2xlYW5pbmclMjBvZmZpY2V8ZW58MHx8fHwxNzgyMzg2NjU4fDA&ixlib=rb-4.1.0&q=85",
    details: [
      "Débarras de tous locaux",
      "Nettoyage et désinfection",
      "Enlèvement d'encombrants et mise en déchetterie",
    ],
  },
  {
    slug: "remise-en-etat",
    icon: "PaintRoller",
    title: "Remise en état avant vente ou location",
    short: "Nettoyage approfondi intérieur et extérieur pour valoriser votre bien.",
    image:
      "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG1vZGVybiUyMGtpdGNoZW4lMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3ODIzODY3NjJ8MA&ixlib=rb-4.1.0&q=85",
    details: [
      "Dépoussiérage et lessivage des surfaces (placards, étagères, plinthes)",
      "Nettoyage approfondi de la cuisine : évier, plan de travail, électroménagers, placards",
      "Détartrage et désinfection des sanitaires (toilettes, salle de bain, douche/baignoire)",
      "Aspiration et lavage des sols (carrelage, parquet, moquette)",
      "Nettoyage des vitres et encadrements",
      "Extérieur : débroussaillage, tonte, taille des haies, petit élagage, nettoyage des allées et terrasses",
    ],
  },
  {
    slug: "nettoyage-vehicule",
    icon: "Car",
    title: "Nettoyage de véhicule int./ext.",
    short: "Nettoyage complet intérieur et extérieur de votre véhicule.",
    image:
      "https://images.unsplash.com/photo-1732357624591-f2137085659b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxzcG90bGVzcyUyMGNhciUyMGludGVyaW9yJTIwZGV0YWlsaW5nfGVufDB8fHx8MTc4MjM4NjY1OHww&ixlib=rb-4.1.0&q=85",
    details: [
      "Intérieur : aspiration et nettoyage des tapis, sièges et coffre",
      "Traitement des plastiques, nettoyage des vitres, désinfection de l'habitacle",
      "Extérieur : prélavage, shampouinage, séchage, lustrage",
    ],
  },
  {
    slug: "entretien-sepultures",
    icon: "Flower2",
    title: "Entretien & fleurissement de sépultures",
    short: "Entretien respectueux et fleurissement de saison des sépultures.",
    image:
      "https://images.unsplash.com/photo-1598146621261-7cdbb2b30d4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxjZW1ldGVyeSUyMGZsb3dlcnMlMjBncmF2ZXN0b25lfGVufDB8fHx8MTc4MjM4Njc2MXww&ixlib=rb-4.1.0&q=85",
    details: [
      "Lavage des surfaces",
      "Nettoyage des plaques",
      "Rénovation des gravures et dorures",
      "Nettoyage des espaces autour de la sépulture",
      "Enlèvement des fleurs fanées et fleurissement de saison",
    ],
  },
  {
    slug: "deratisation",
    icon: "ShieldCheck",
    title: "Dératisation",
    short: "Des solutions adaptées selon votre situation.",
    cardShort: "Traitements préventifs et curatifs, ponctuels ou réguliers.",
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_proprete-cahors/artifacts/kc3m6yui_Deratisation.png",
    details: [
      "Veille préventive",
      "Traitement curatif",
      "Services ponctuels et prestations régulières",
      "Particuliers et professionnels",
    ],
  },
  {
    slug: "desinsectisation",
    icon: "Bug",
    title: "Désinsectisation",
    short: "Des services rapides, efficaces, tranquillité assurée !",
    cardShort: "Lutte contre tout insecte nuisible. Des services rapides et efficaces.",
    image:
      "https://customer-assets-m6fa6gv7.emergentagent.net/job_proprete-cahors/artifacts/33ef5djx_DESINSECTISATION.webp",
    details: [
      "Guêpes, frelons",
      "Puces, punaises de lit",
      "Fourmis",
      "Blattes, cafards",
      "Termites et insectes xylophages",
    ],
  },
];

// Tarifs indicatifs — à ajuster avec vos prix exacts
export const PACKAGES = [
  {
    name: "Essentiel",
    price: "24",
    unit: "€ / h",
    from: true,
    popular: false,
    desc: "Pour un entretien ponctuel ou un coup de propre.",
    features: [
      "Ménage intérieur ponctuel",
      "Nettoyage des sols et surfaces",
      "Produits inclus",
      "Sans engagement",
    ],
  },
  {
    name: "Confort",
    price: "19",
    unit: "€ / h",
    from: true,
    popular: true,
    desc: "Entretien régulier de votre résidence, vos locaux (abonnement).",
    features: [
      "Passages réguliers",
      "Tarif horaire préférentiel",
      "Même intervenant à chaque passage",
      "Services sur-mesure",
      "Adaptable à tout type de services",
    ],
  },
  {
    name: "Sur mesure",
    price: "Devis",
    unit: "personnalisé",
    from: false,
    popular: false,
    desc: "Remise en état, débarras, espaces verts, professionnels.",
    features: [
      "Évaluation gratuite sur place",
      "Devis détaillé sous 48h",
      "Solutions B2B & locations saisonnières",
      "Prestations combinées",
    ],
  },
];

export const SERVICE_RATES = [
  { service: "Ménage & entretien intérieur", price: "À partir de 24 €/h" },
  { service: "Entretien extérieur & espaces verts", price: "À partir de 36 €/h" },
  { service: "Nettoyage de surfaces vitrées", price: "À partir de 4,20 €/fenêtre" },
  { service: "Débarras & désinfection", price: "Sur devis" },
  { service: "Remise en état avant vente/location", price: "Sur devis" },
  { service: "Nettoyage de véhicule", price: "À partir de 60 €" },
  { service: "Entretien & fleurissement de sépultures", price: "À partir de 55 € / passage" },
];

export const TESTIMONIALS = [
  {
    name: "Andrée P.",
    city: "Gourdon",
    type: "Particulier",
    text: "Une équipe ponctuelle et minutieuse. Ma résidence secondaire est toujours impeccable à mon arrivée. Je recommande vivement !",
    rating: 5,
  },
  {
    name: "Florence T.",
    city: "Cahors",
    type: "Particulier",
    text: "Débarras et nettoyage rapide de mon garage laissé à l'abandon depuis plusieurs mois. Il y avait de tout, même des cadavres de rats, beurk ! C'est rangé, propre et ça sent bon :-)",
    rating: 5,
  },
  {
    name: "Jean-Pierre L.",
    city: "Francoulès",
    type: "Particulier",
    text: "Ils entretiennent la sépulture de mes parents avec beaucoup de respect et de délicatesse. Un grand merci.",
    rating: 5,
  },
  {
    name: "Camille R.",
    city: "Cazals",
    type: "Particulier",
    text: "Débarras complet d'un local en une journée. Travail propre et personnel très professionnel.",
    rating: 5,
  },
];

export const GALLERY = [
  {
    title: "Cuisine — remise en état",
    before: "https://images.pexels.com/photos/4239130/pexels-photo-4239130.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    after: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMG1vZGVybiUyMGtpdGNoZW4lMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3ODIzODY3NjJ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Terrasse & extérieur",
    before: "https://images.unsplash.com/photo-1774979163719-26b41c6c8c05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHx0aWR5JTIwZ2FyZGVuJTIwdGVycmFjZSUyMG1haW50ZW5hbmNlfGVufDB8fHx8MTc4MjM4Njc2MXww&ixlib=rb-4.1.0&q=85",
    after: "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Vitres & baies vitrées",
    before: "https://images.pexels.com/photos/4239037/pexels-photo-4239037.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    after: "https://images.pexels.com/photos/31435403/pexels-photo-31435403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const ZONES = [
  "Cahors", "Francoulès", "Cazals", "Mercuès", "Pradines", "Catus",
  "Luzech", "Labastide-Murat", "Espère", "Caillac", "Crayssac", "Douelle",
  "Saint-Géry-Vers", "Montcuq", "Puy-l'Évêque", "Gourdon",
];


export const SOCIAL_VISUALS = [
  {
    slug: "story",
    title: "Story — Facebook & Instagram",
    format: "Format vertical (story)",
    filename: "equinoxe-proprete-story.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/7d274ad34d1f3b58fc08ff36b0b61df7bad9ebac1a952f65ef3513e5bc219136.png",
  },
  {
    slug: "feed",
    title: "Publication — Feed carré",
    format: "Format carré (1:1)",
    filename: "equinoxe-proprete-post-carre.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/8f4458026a85f0f8417801e1c68b7858cd82523511ffb146309a5ca82a4b7912.png",
  },
  {
    slug: "story-menage-interieur",
    title: "Story — Ménage & entretien intérieur",
    format: "Story (vertical)",
    filename: "equinoxe-story-menage-interieur.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/94a0cab1cfb5a02f5b5d766e09dc8824a88eb9fc0f5d7d906259ca329dba626e.png",
  },
  {
    slug: "story-espaces-verts",
    title: "Story — Entretien extérieur & espaces verts",
    format: "Story (vertical)",
    filename: "equinoxe-story-espaces-verts.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/569d17dad97054efe5ec8a07bbf4c4e478eefb48a0ab70085f0e7db1a0dfd110.png",
  },
  {
    slug: "story-vitres",
    title: "Story — Nettoyage de surfaces vitrées",
    format: "Story (vertical)",
    filename: "equinoxe-story-vitres.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/68e4807930fa379bb211eb3fd07db8d484377b620f3b52bc13f385dfdf3d8d5a.png",
  },
  {
    slug: "story-debarras",
    title: "Story — Débarras & désinfection",
    format: "Story (vertical)",
    filename: "equinoxe-story-debarras.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/051ea24d71ceb4dcb23e6289e178443dc281d83c1f90f632b3b27237593a3c55.png",
  },
  {
    slug: "story-remise-en-etat",
    title: "Story — Remise en état avant vente ou location",
    format: "Story (vertical)",
    filename: "equinoxe-story-remise-en-etat.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/1e82615b4a225edcbc1c7e2ea1900d0a50de243c16147e1277a694e185be8c78.png",
  },
  {
    slug: "story-vehicule",
    title: "Story — Nettoyage de véhicule",
    format: "Story (vertical)",
    filename: "equinoxe-story-vehicule.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/b97fddcd46c2ad18a4078849e62a28470235f4a5edb6040cb93071a10d5686db.png",
  },
  {
    slug: "story-sepultures",
    title: "Story — Entretien & fleurissement de sépultures",
    format: "Story (vertical)",
    filename: "equinoxe-story-sepultures.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/acda499a03b4f94d1e5282f4436caf8266da9ce400a55807447a8c88404120ed.png",
  },
  {
    slug: "story-deratisation",
    title: "Story — Dératisation",
    format: "Story (vertical)",
    filename: "equinoxe-story-deratisation.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/0be096e1ecf39af649be14d2aa42ed3883fd1141c41921e1a76127a990f2f4cd.png",
  },
  {
    slug: "story-desinsectisation",
    title: "Story — Désinsectisation",
    format: "Story (vertical)",
    filename: "equinoxe-story-desinsectisation.png",
    url: "https://static.prod-images.emergentagent.com/jobs/c0df428a-f30d-408b-9fd0-f73c669b11e7/images/489939d502fabf4ca9bb912f9addd337b789347a70125e6ece7694e9a34f02ec.png",
  },
];
